<div class="flex min-h-screen bg-[#fafaf7]">
  <app-sidebar></app-sidebar>
  <div class="flex-1 flex flex-col min-w-0">
    <app-header></app-header>
    <main class="flex-1 p-4 sm:p-6">
      <div class="max-w-[1200px] mx-auto">
        <router-outlet></router-outlet>
      </div>
    </main>
  </div>
</div>
